import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Grid, Typography } from "@mui/material";
import VisibilityFilter from "./Visibility";
import OrganizationAutocomplete from "../../../AutocompleteInputs/OrganizationAutocomplete";
import TagsFilter from "./Tags";
import {
    clearStacksFilter,
    adminSliceSelectors,
    setStacksFilter,
    setActiveStack,
} from "../../../../slices/Admin/adminSlice";
import { getStacks } from "../../../../actions/Admin/Stacks";
import SearchComponent from "../../../Search";

export default function Filter() {
    const filter = useSelector(adminSliceSelectors.stacksFilter);
    const dispatch = useDispatch();

    const handleClearAll = () => {
        dispatch(clearStacksFilter());
    };

    const handleOrganizationSelected = (organization) => {
        if (!organization) {
            dispatch(clearStacksFilter());
            return;
        }

        dispatch(setStacksFilter({ q: { ...filter.q, organization } }));
        dispatch(getStacks({ organization_id: organization.id, name: filter.q.name }));
        dispatch(setActiveStack({ organization }));
    };

    const onSearch = (value) => {
        dispatch(setStacksFilter({ q: { ...filter.q, name: value } }));

        if (!filter.q.organization.id) return;

        dispatch(getStacks({ organization_id: filter.q.organization.id, name: value }));
    };

    return (
        <Box p={2.5}>
            <SearchComponent value={filter?.q?.name} onSearch={onSearch} label="Search here..." />
            <Box mt={3} mb={3}>
                <Grid container alignItems="center">
                    <Grid item>
                        <Typography variant="h6" color="text.onPrimary">
                            Filters
                        </Typography>
                    </Grid>
                    <Grid item xs container direction="column" alignItems="flex-end" justifyContent="flex-start">
                        <Button variant="text" color="primary" size="small" onClick={handleClearAll}>
                            CLEAR ALL
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <Box mt={3} mb={3}>
                <VisibilityFilter />
            </Box>
            <Box mt={3} mb={3}>
                <OrganizationAutocomplete
                    defaultValue={filter.q.organization.full_name}
                    onSelected={handleOrganizationSelected}
                />
            </Box>
            <Box mt={3} mb={3}>
                <TagsFilter />
            </Box>
        </Box>
    );
}
